import { createFeatureSelector, createSelector } from '@ngrx/store';
import { authFeatureKey, AuthState } from '../auth-state';
import { LoadedUser } from '../models/user';

export const selectAuthState = createFeatureSelector<AuthState>(authFeatureKey);

export const selectImpersonatedClientId = createSelector(selectAuthState, state => state.impersonatedClientId);
export const selectSignedInClientId = createSelector(selectAuthState, state => state.signedInClientId);
export const selectIsSignedInClientValid = createSelector(selectAuthState, state => state.isSignedInClientValid);

export const selectUser = createSelector(selectAuthState, state => state.user);

export const selectLoadedUser = createSelector(selectAuthState, state =>
  state.isLoaded ? (state.user as LoadedUser) : undefined
);

export const selectCurrentClientId = createSelector(
  selectLoadedUser,
  selectImpersonatedClientId,
  selectSignedInClientId,
  (loadedUser, impersonatedClientId, signedInClientId) =>
    impersonatedClientId || signedInClientId || loadedUser?.clientId
);
